/**
 * Plate -> { status, branch, km } of every car. Keys: the plate as stored ("AA 12345") and its
 * normalized form ("aa12345"), the form the pages look up. Built from cars already loaded, so a
 * page that has the fleet does not read it a second time just for the map.
 */
export const statusMapOf = (cars) => {
    const map = {};
    let lastUpdated = null;
    (cars || []).forEach((car) => {
        const plate = String(car?.plate_number ?? '').trim();
        if (!plate) return;
        const entry = { status: car.status || '', branch: car.branch || '', km: car.current_km ?? '' };
        map[plate] = entry;
        map[plate.toLowerCase().replace(/\s+/g, '')] = entry;
        if (car.last_updated && (!lastUpdated || car.last_updated > lastUpdated)) lastUpdated = car.last_updated;
    });
    return { map, last_updated: lastUpdated };
};
